export default "__VITE_ASSET__CwQUbBXu__"